import EventClassroom from './EventClassroom';

export default EventClassroom;
